import React from 'react';
import { Container, Row, Col, Card, CardHeader } from 'reactstrap';
import { Colorcode, ColoredBreadcrumb, useclass } from '../../../Constant';
import { Breadcrumbs, H5 } from '../../../AbstractElements';
import RibbonClass from './RibbonClass';
import RibbonComponent from './RibbonCommon';

const RibbonsContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs parent='Bonus Ui' title='Ribbons' pageTitle='Ribbons' />
      <Row>
        <Col sm='12' xl='12'>
          <Card>
            <CardHeader className='pb-0'>
              <H5>{ColoredBreadcrumb}</H5>
              <span>
                {useclass} <code>{Colorcode}</code>
              </span>
            </CardHeader>
            <RibbonClass />
          </Card>
        </Col>
        <RibbonComponent />
      </Row>
    </Container>
  );
};

export default RibbonsContainer;
